module.exports = __webpack_public_path__ + "img/082.2763441e.jpeg";